/* =============================================================================
   HUSL Beauty — The Beauty Edit / Beauty Compass category filter  (v2)
   Page: /blogs/the-beauty-edit

   WHAT v2 ADDS (option 1)
   When you click a category tab, the big FEATURED hero at the top now updates
   to that category's newest story (and the grid below filters to that category,
   with the featured story de-duplicated so it doesn't also show as a card).
   Clicking "All" restores the site's overall newest story.

   REQUIREMENTS
   - Pills:  <button class="be-filter-pill" data-filter="...">   (already there)
   - Cards:  .be-grid-section .be-card[data-tags]                (already there)
   - Hero :  .be-featured  with the standard inner elements       (already there)
   - Data :  <script type="application/json" id="be-featured-data"> … </script>
             (add the accompanying Liquid block to the template — see the
             be-featured-data.liquid file. If it's missing, the hero simply
             won't swap, but the grid filtering still works.)

   INSTALL
   1. Replace the entire contents of assets/be-filter.js with this file.
   2. Add the Liquid data block to templates/blog.beauty-edit.liquid (see steps).
   ============================================================================= */
(function () {
  'use strict';

  if (window.__beFilterInit) return;
  window.__beFilterInit = true;

  var ACTIVE = 'active';
  var currentFilter = 'all';

  var FEATURED = (function () {
    var el = document.getElementById('be-featured-data');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  })();

  function tagsOf(card) {
    return (card.getAttribute('data-tags') || '')
      .toLowerCase().split(/[\s,]+/).filter(Boolean);
  }

  function setText(scope, sel, val) {
    var n = scope.querySelector(sel);
    if (n && val != null) n.textContent = val;
  }

  function updateFeatured(filter) {
    var sec = document.querySelector('.be-featured');
    var data = FEATURED[filter] || FEATURED.all;
    if (!sec || !data) return;

    var img = sec.querySelector('.be-featured-image img');
    if (img && data.image) { img.src = data.image; img.alt = data.title || ''; }

    setText(sec, '.be-featured-category', data.category);
    setText(sec, '.be-featured-title', data.title);
    setText(sec, '.be-featured-excerpt', data.excerpt);
    setText(sec, '.be-featured-author', data.author);
    setText(sec, '.be-featured-date', data.date);

    var link = sec.querySelector('.be-read-link');
    if (link && data.url) link.setAttribute('href', data.url);

    sec.setAttribute('data-tags', filter === 'all' ? (data.tag || '') : filter);
    sec.setAttribute('data-featured-url', data.url || '');
  }

  function applyFilter(bar, filter) {
    currentFilter = (filter || 'all').toLowerCase();

    updateFeatured(currentFilter);
    var featuredUrl = ((FEATURED[currentFilter] || FEATURED.all || {}).url) || '';

    var grid = document.querySelector('.be-grid-section');
    if (grid) {
      var cards = grid.querySelectorAll('.be-card[data-tags]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var match = currentFilter === 'all' || tagsOf(card).indexOf(currentFilter) !== -1;
        var a = card.querySelector('a[href]');
        var isDupOfFeatured = a && featuredUrl && a.getAttribute('href') === featuredUrl;
        if (match && !isDupOfFeatured) {
          card.removeAttribute('data-hidden');
          // Category filter: show all matches (ignore Load More paging).
          if (currentFilter !== 'all') card.removeAttribute('data-page-hidden');
        } else {
          card.setAttribute('data-hidden', 'true');
        }
      }
    }

    var pills = bar.querySelectorAll('.be-filter-pill');
    for (var j = 0; j < pills.length; j++) {
      var on = (pills[j].getAttribute('data-filter') || '').toLowerCase() === currentFilter;
      pills[j].classList.toggle(ACTIVE, on);
      pills[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function init() {
    var bar = document.querySelector('.be-filter-bar');
    if (!bar || bar.__beBound) return;
    bar.__beBound = true;

    bar.addEventListener('click', function (e) {
      var pill = e.target.closest('.be-filter-pill');
      if (!pill || !bar.contains(pill)) return;
      e.preventDefault();
      applyFilter(bar, pill.getAttribute('data-filter'));
    });

    var current = bar.querySelector('.be-filter-pill.' + ACTIVE);
    applyFilter(bar, current ? current.getAttribute('data-filter') : 'all');

    var grid = document.querySelector('.be-grid-section');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { applyFilter(bar, currentFilter); })
        .observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
